import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Wrapper = styled.div(() =>
  mq({
    borderTop: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    padding: `32px 0 ${defaultTheme.spacing.l}`,
    marginTop: '64px',
  }),
);

export const OpinionArea = styled.div(() =>
  mq({
    display: 'block',
    fontSize: defaultTheme.font.size.m,
    textAlign: 'center',
    marginBottom: '64px',
  }),
);

export const OpinionLink = styled.a(() =>
  mq({
    textDecorationLine: 'underline',
    ...hoverOpacity,
  }),
);

export const ShareArea = styled.div(() =>
  mq({
    textAlign: 'center',
    '& > p': {
      fontSize: defaultTheme.font.size.m,
      fontWeight: 'bold',
    },
  }),
);

export const LinksWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 40px)',
    gridGap: defaultTheme.spacing.l,
    justifyContent: 'center',
    marginTop: defaultTheme.spacing.l,
    '& > a': {
      ...hoverOpacity,
      '& > img': {
        width: '40px',
        height: '40px',
      },
    },
  }),
);
